import { postHostedDocumentsByIdUploadBySideMutation } from '@onefootprint/fetch-hosted';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { DOC_UPLOAD_TIMEOUT_MS } from '../constants';
const isTimeoutError = (err: unknown): boolean => err instanceof DOMException && err.name === 'TimeoutError';
const useSubmitDoc = () => {
  const {
    t
  } = useTranslation('request', {
    keyPrefix: 'errors'
  });
  const mutation = postHostedDocumentsByIdUploadBySideMutation();
  return useMutation({
    ...mutation,
    mutationFn: async (options, context) => {
      const {
        mutationFn
      } = mutation;
      if (!mutationFn) {
        throw new Error('postHostedDocumentsByIdUploadBySideMutation is missing mutationFn');
      }
      try {
        return await mutationFn({
          ...options,
          signal: options.signal ?? AbortSignal.timeout(DOC_UPLOAD_TIMEOUT_MS)
        }, context);
      } catch (err) {
        if (isTimeoutError(err)) {
          throw {
            status: 408,
            message: t($ => $.E121),
            code: 'E121'
          };
        }
        throw err;
      }
    }
  });
};
export default useSubmitDoc;